import { DashboardApi20240730 } from '@sequencehq/api/dashboard/v20240730'
import { ActiveFilter } from '@sequencehq/core-components'
import { SavedView, SavedViewBody } from './savedViews.types'

export type GetSavedViewsResponse =
  DashboardApi20240730.GetSavedViews.GetSavedViewsResponse

type ApiSavedViewActiveFilters = {
  version: number
  activeFilters: ActiveFilter[]
}

const isSavedViewActiveFilters = (
  apiActiveFilters: unknown
): apiActiveFilters is ApiSavedViewActiveFilters => {
  return (
    typeof apiActiveFilters === 'object' &&
    apiActiveFilters !== null &&
    'version' in apiActiveFilters &&
    'activeFilters' in apiActiveFilters &&
    Array.isArray(apiActiveFilters.activeFilters)
  )
}

const apiActiveFiltersToSavedViewAttributes = (
  activeFiltersApiAttribute: unknown
): { activeFilters: ActiveFilter[]; sortBy: string | null } => {
  if (!isSavedViewActiveFilters(activeFiltersApiAttribute)) {
    return { activeFilters: [], sortBy: null }
  }

  const sortBy =
    'sortBy' in activeFiltersApiAttribute
      ? String(activeFiltersApiAttribute.sortBy)
      : null

  return {
    activeFilters: activeFiltersApiAttribute.activeFilters,
    sortBy
  }
}

const savedViews = {
  fromServer: (response: GetSavedViewsResponse): SavedView[] => {
    return response.items.map(savedView => ({
      ...savedView,
      ...apiActiveFiltersToSavedViewAttributes(savedView.activeFilters)
    }))
  }
}

const savedView = {
  toServer: (savedView: SavedViewBody) => {
    return {
      ...savedView,
      activeFilters: {
        version: 1,
        activeFilters: savedView.activeFilters,
        sortBy: savedView.sortBy ?? undefined
      }
    }
  }
}

export const savedViewsPorts = {
  savedView,
  savedViews
}
